var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteComp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 6,
    fill: "#EA5455",
    fillOpacity: 0.48
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 15.25H25",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 15.25L14.5 24.25C14.5 25.0784 15.1716 25.75 16 25.75H22C22.8284 25.75 23.5 25.0784 23.5 24.25L24.25 15.25",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.75 15.25V13C16.75 12.5858 17.0858 12.25 17.5 12.25H20.5C20.9142 12.25 21.25 12.5858 21.25 13V15.25",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0303 18.4697C17.7374 18.1768 17.2626 18.1768 16.9697 18.4697C16.6768 18.7626 16.6768 19.2374 16.9697 19.5303L18.0303 18.4697ZM19.9697 22.5303C20.2626 22.8232 20.7374 22.8232 21.0303 22.5303C21.3232 22.2374 21.3232 21.7626 21.0303 21.4697L19.9697 22.5303ZM21.0303 19.5303C21.3232 19.2374 21.3232 18.7626 21.0303 18.4697C20.7374 18.1768 20.2626 18.1768 19.9697 18.4697L21.0303 19.5303ZM16.9697 21.4697C16.6768 21.7626 16.6768 22.2374 16.9697 22.5303C17.2626 22.8232 17.7374 22.8232 18.0303 22.5303L16.9697 21.4697ZM16.9697 19.5303L19.9697 22.5303L21.0303 21.4697L18.0303 18.4697L16.9697 19.5303ZM19.9697 18.4697L16.9697 21.4697L18.0303 22.5303L21.0303 19.5303L19.9697 18.4697Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteComp);
export default __webpack_public_path__ + "static/media/delete-comp.e51878d28b8a63c901bff5e7149adf79.svg";
export { ForwardRef as ReactComponent };